import { useState } from 'react';
import Button from 'components/Button';
import copyFormatted from 'utils/copyFormattedHTML';
import { sourcePageHref, sourcePageText } from 'utils/source-page';
import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

const escapeHtml = (value) =>
    String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

// The alert's source page, offered to the writer; the link only goes into the story if they paste it.
const SuggestedLink = ({ alert }) => {
    const [copied, setCopied] = useState(false);
    const href = sourcePageHref(alert.sourceUrl, alert.slug);
    if (!href) return null;

    const text = sourcePageText(alert.sourceLabel, alert.sourceUrl);
    // Matches the editor's "Sponsored link" decorator, so the rel survives the paste.
    const rel = alert.isSponsored ? ' rel="nofollow sponsored"' : '';

    return (
        <div className={[styles.seo, styles.suggestedLink].join(' ')}>
            <span className={styles.kicker}>Suggested link</span>
            <p className={styles.hint}>
                The alert&rsquo;s source page
                {alert.isSponsored ? ' (sponsored)' : ''}. Copy it into the
                story where it fits, or leave it out.
            </p>
            <a href={href} target="_blank" rel="noopener noreferrer">
                {text}
            </a>
            <Button
                theme={'secondary'}
                title={copied ? 'Copied' : 'Copy link'}
                onClick={() => {
                    copyFormatted(
                        `<a href="${escapeHtml(href)}"${rel}>${escapeHtml(
                            text
                        )}</a>`
                    );
                    setCopied(true);
                }}
            />
        </div>
    );
};

export default SuggestedLink;
